// extracted by mini-css-extract-plugin
module.exports = {"varietySelect":"VarietyFilter_varietySelect__2yLXO","selectboxFilterWrapper":"VarietyFilter_selectboxFilterWrapper__2P1vG"};